export const MinDocViewerWidth = 380;
export const MinDocDetailWidth = 190;
export const MinPageContentWidth = 560;
